import _ from 'lodash';
import React, { useEffect, useState, useContext } from 'react';
import { FormInputContainer, FormContext } from 'blaze-form';
import { Button, ButtonGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import BlazeInputReactSelect from 'blaze-input-react-select';
import Skeleton from 'react-loading-skeleton';
import ApiService from '../../../services/ApiService';
import { modal } from '../../modal/ModalEmitter';

const setValueKey = o => {
  return {
    ...o,
    label: o.displayName || o.label || o.name,
    value: String(o.id !== undefined ? o.id : o.value),
    isDisabled: o.disabled === true,
  };
};

const FormInputLoyaltyCustomer = ({ search = {}, field, ...props }) => {
  const [loading, setLoading] = useState(true);
  const [options, setOptions] = useState([]);
  const [validationKeyValue, setValidationKeyValue] = useState(_.get(props.search, 'keyValue'));
  const [addedValue, setAddedValue] = useState(null);
  const [addedOption, setAddedOption] = useState(null);
  const [key, setKey] = useState(0);

  const { ee } = useContext(FormContext);

  const consume = ({ action, payload: data }) => {
    if (action === 'sync') {
      if (search.key && data[search.key]) {
        setValidationKeyValue(data[search.key].data);
      }
    }
  };

  const onCreate = response => {
    setAddedValue(_.get(response, 'data.externalCustomerId'));
    getOptions();
    modal.close();
  };

  const onSelect = selection => {
    const newOption = setValueKey({ ...selection, id: String(selection.externalCustomerId) });
    setAddedValue(selection.externalCustomerId);
    setAddedOption(newOption);
    setOptions(current => [...current, newOption]);
    newOption.customerNum = validationKeyValue;
    props.onChange(field.name, newOption.value);
    linkCustomer(newOption);
    modal.close();
  };

  const linkCustomer = customer => {
    return ApiService.post(`/loyalty/customers/${customer.id}/link`, customer);
  };

  const openAddCustomer = () => {
    modal.open('loyaltyCustomerUpdate', { onCreate, initialValues: { customerNum: validationKeyValue } });
  };

  const openSearchCustomer = () => {
    modal.open('loyaltyCustomerSearch', { onSelect });
  };

  const getOptions = () => {
    const defaultUrl = '/search/db/loyaltycustomer';

    if (!validationKeyValue) {
      setLoading(false);
      return Promise.resolve([]);
    }

    if (!search.params) {
      search.params = {};
    }

    if (validationKeyValue) {
      search.params.filter = btoa(JSON.stringify({ customerNum: validationKeyValue.toLowerCase() }));
    }

    return ApiService.get(defaultUrl, { params: search.params || {} })
      .then(response => {
        const list = _.get(response, 'data.list') || response.data || [];

        const newOptions = list.map(setValueKey);

        if (!field.noEmptyOption) {
          newOptions.unshift(search.emptyOption || { label: '', value: '' });
        }

        if (addedOption) {
          setOptions([...newOptions, addedOption]);
        } else {
          setOptions(newOptions);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formatOptionLabel = ({ id, firstName, lastName }) => {
    if (!id) {
      return <div>&nbsp;</div>;
    }

    return (
      <div>
        {firstName} {lastName}
      </div>
    );
  };

  const getValue = () => {
    if (addedValue) {
      return String(addedValue);
    }

    return field.data ? field.data : options[0];
  };

  useEffect(() => {
    if (ee) {
      ee.on('syncForm', (...args) => {
        setTimeout(() => {
          consume(...args);
        }, 10);
      });
    }

    return () => {
      if (ee) {
        ee.off('syncForm');
      }
    };
  }, []);

  useEffect(() => {
    setKey(current => current + 1);
  }, [options]);

  useEffect(() => {
    getOptions();
  }, [validationKeyValue]);

  const inputProps = field.inputProps || {};

  if (formatOptionLabel) {
    inputProps.formatOptionLabel = formatOptionLabel;
  }

  if (loading) {
    return (
      <FormInputContainer {...props} field={{ ...field, inputProps: { ...inputProps, formatOptionLabel } }}>
        <Skeleton style={{ height: '35px', lineHeight: 'inherit' }} />
      </FormInputContainer>
    );
  }

  const initialValue = getValue();

  return (
    <>
      <BlazeInputReactSelect
        key={key}
        {...props}
        loading={loading}
        field={{
          ...field,
          options,
          inputProps: { ...inputProps, formatOptionLabel },
          disabled: !validationKeyValue,
        }}
        value={initialValue}
      />
      <div className="input-toolbar-wrapper">
        <div className="input-toolbar">
          <ButtonGroup>
            <Button onClick={openSearchCustomer} variant="primary" size="sm" disabled={!validationKeyValue}>
              <i className="fas fa-search" />
            </Button>
            <Button onClick={openAddCustomer} variant="success" size="sm" disabled={!validationKeyValue}>
              <i className="fas fa-plus" />
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </>
  );
};

FormInputLoyaltyCustomer.propTypes = {
  field: PropTypes.object,
  search: PropTypes.object,
};

export default FormInputLoyaltyCustomer;
